import { c as _c } from "react/compiler-runtime";
import { BodyLong, GuidePanel } from "@navikt/ds-react";
import { useBehovContextState } from "@/app/(behov)/[behovId]/state/contextState";
import { UiSelector } from "@/utils/uiSelectors";
export default function OppgiLederPanel() {
  const $ = _c(12);
  const {
    lederInfo
  } = useBehovContextState();
  let t0;
  if ($[0] !== lederInfo.sykmeldt.fullnavn || $[1] !== lederInfo.sykmeldtFnr) {
    t0 = <strong>{lederInfo.sykmeldt.fullnavn} ({lederInfo.sykmeldtFnr})</strong>;
    $[0] = lederInfo.sykmeldt.fullnavn;
    $[1] = lederInfo.sykmeldtFnr;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== lederInfo.orgnavn) {
    t1 = lederInfo.orgnavn ? <span><strong>{lederInfo.orgnavn}</strong></span> : " organisasjonen/virksomheten";
    $[3] = lederInfo.orgnavn;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = <BodyLong spacing={true}>{t0}{" "}er sykmeldt. Nav mangler informasjon om hvem som er nærmeste leder for den sykmeldte i{" "}{t1}. Personen som oppgis som nærmeste leder, får tilgang den sykmeldte ansatte og oppfølgingstjenestene Nav tilbyr på "Dine sykmeldte" hos Nav.</BodyLong>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <BodyLong spacing={true}>Vi har forhåndsutfylt skjemaet med navn og fødselsnummer til den ansatte. Du må legge inn kontaktinformasjonen til lederen som skal få tilgang.</BodyLong>;
    t4 = <BodyLong>Den ansatte vil se hvem som er meldt inn som nærmeste leder på "Ditt sykefravær" hos Nav.</BodyLong>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2) {
    t5 = <GuidePanel poster={true} data-testid={UiSelector.OppgiLederPanel}>{t2}{t3}{t4}</GuidePanel>;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}